import api from './api'
import whatEatApi from '@/apis/whatEatApi'

export default Vue => {
	api(Vue)
	whatEatApi(Vue)
}
